export default {
  REQUEST: '@resetPassword/REQUEST',
};
